import { TicketSelFilterFormValues, TicketSelFilterFormValuesPaginated } from 'features/transaction_list/component/ticket-selection-filter-form/type';
import { TicketSelectionList } from 'features/transaction_list/component/ticket-selection-table/ticket-selection-list';
import { TicketSelectionTopBar } from 'features/transaction_list/component/top-bar/ticket-selection-topbar';
import { useGetTicketSelectionList } from 'features/transaction_list/use-cases/get-ticket-selection';
import { usePaginationParams } from 'hooks';
import { Outlet } from 'react-router-dom';

const getInitialFilterValues: TicketSelFilterFormValues = {
    SearchFirstName: undefined,
    SearchLastName: undefined,
    SearchEmail: undefined,
    SearchEventName: undefined,
};

export const TicketSelectionView = () => {
    const { params, updateParams, resetPage } = usePaginationParams<TicketSelFilterFormValuesPaginated>({
        page: 1,
        size: 10,
        ...getInitialFilterValues,
    });
    const { data, refetch, isFetching } = useGetTicketSelectionList(params, { retry: false });
    const handleFiltersChange = (values: TicketSelFilterFormValuesPaginated) => {
        updateParams(values);
        resetPage();
        refetch()
    };

    return (

        <>
            <TicketSelectionTopBar
                handleFilter={handleFiltersChange}
                getInitialFilterValues={getInitialFilterValues}
            // refetch={""}
            />
            <TicketSelectionList
                isSocialListLoading={isFetching}
                DeliveryList={data}
                tableParams={params}
                updateParams={updateParams}
                refetch={refetch}

            />
            <Outlet />
        </>
    );
};
